import http from "../index"
import {
    apiCreatePrice,
    apiDetailPrice,
    apiListPrice,
    apiUpdateList,
    apiUpdatePrice,
} from "./urls"

const getListPrice = params => http.get(apiListPrice, { params }) 
const getDetailPrice = (id) => http.get(apiDetailPrice(id))
const createPrice = params => http.post(apiCreatePrice, params)
const updatePrice = (id, params) => http.put(apiUpdatePrice(id), params)
const updateList = (id) => http.put(apiUpdateList(id))

const SettingPriceService = {
    getListPrice,
    getDetailPrice,
    createPrice,
    updatePrice ,
    updateList
}
export default SettingPriceService